export default __webpack_public_path__ + "static/media/3-cloudxier-shooper-highlight02.a5c0cc54.jpg";